import * as yup from "yup";

const brandValidation = yup.object().shape({
  name: yup.string().required("Bu alan zorunludur"),
});

export default brandValidation;
